// Minimal path-based router. Vite (dev + preview) serves index.html as the SPA
// fallback, so History API paths like /admin work without extra nginx config.

let path = $state(window.location.pathname);

/** Reactive current pathname — call inside a `$derived`/template to track it. */
export function currentPath(): string {
  return path;
}

/** Push a new path without a full reload. */
export function navigate(to: string): void {
  if (to === path) return;
  history.pushState({}, '', to);
  path = to;
}

/**
 * Update the query string of the *current* page in place, without a route
 * change or reload. Keys whose value is null/'' are dropped; the rest are set.
 * Uses replaceState so filter toggles don't spam the history stack. The router
 * keys off pathname only, so this never retriggers a route swap — pages read
 * `window.location.search` at init and own their own filter state afterward.
 */
export function setQuery(params: Record<string, string | null | undefined>): void {
  const sp = new URLSearchParams(window.location.search);
  for (const [k, v] of Object.entries(params)) {
    if (v == null || v === '') sp.delete(k);
    else sp.set(k, v);
  }
  const qs = sp.toString();
  const to = window.location.pathname + (qs ? `?${qs}` : '');
  history.replaceState({}, '', to);
}

window.addEventListener('popstate', () => {
  path = window.location.pathname;
});
